import RoleDetailModal from './role-detail-modal.vue'
export default RoleDetailModal
